"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpCommand = void 0;
const AbstractCommand_1 = require("./AbstractCommand");
class SignUpCommand extends AbstractCommand_1.AbstractCommand {
    constructor(input) {
        super(input);
        this.input = input;
    }
    async execute(config) {
        return this.getCommandService(config).doTrackSignUpEvent(this.input);
    }
}
exports.SignUpCommand = SignUpCommand;
